export const supportPortals = [
  {
    Name: "",
    Link: process.env.REACT_APP_RewardlePay_Potal,
    SubTitle: "RewardlePay"
  },
  {
    Name: "",
    Link: process.env.REACT_APP_Payments_Admin_Potal,
    SubTitle: "PaymentAdmin"
  },
  {
    Name: "",
    Link: process.env.REACT_APP_BuisnessDevices_Frontend,
    SubTitle: "BuisnessDevices"
  },
  {
    Name: "",
    Link: process.env.REACT_APP_BillingPlatform_Portal,
    SubTitle: "BillingPlatform"
  },
  {
    Name: "",
    Link: process.env.REACT_APP_CardPanels_Frontend,
    SubTitle: "CardPanels"
  },
  {
    Name: "",
    Link: process.env.REACT_APP_PromoCodesPanels_Frontend,
    SubTitle: "PromoCodes"
  },
  {
    Name: "",
    Link: process.env.REACT_APP_Liability_Portal,
    SubTitle: "Liability"
  }
];

export const businessPortals = [
  {
    Name: "",
    Link: process.env.REACT_APP_Payments_Potal,
    SubTitle: "Payments"
  }
];

export const patronsPortals = [
  {
    Name: "",
    Link: process.env.REACT_APP_Patrons_Portal,
    SubTitle: "Patrons"
  }
];

export const commingSoonPortals = [
  {
    Name: "",
    Link: process.env.REACT_APP_Tags_Potal,
    SubTitle: "Tags"
  }
];

export const settingsCategories = [
  "rewards",
  "checkin",
  "sharing",
  "prepaid",
  "profile"
];

export const sendPushOptions = [
  "EMAIL_DB",
  "SYNC_DOWN_MERCHANT_DATA",
  "SYNC_DOWN_CREDITS",
  "SYNC_DOWN_PROMOTION_PATRONS",
  "SYNC_DOWN",
  "SYNC_UP"
];

export const statusColor: any = {
  yes: {
    color: "#C8E6C9",
    title: "Successful"
  },
  no: {
    color: "#FD3B51",
    title: "Failed"
  }
};

/**
 * Badge colours for support email-change recovery statuses. Keys are compared
 * lower-cased, so any casing the backend sends still resolves.
 */
export const recoveryStatusColor: any = {
  active: "#C8E6C9",
  completed: "#C8E6C9",
  superseded: "#E0E0E0",
  expired: "#FFE0B2",
  consumed: "#E0E0E0",
  incomplete: "#FFCDD2",
  failed: "#FFCDD2"
};

export const defaultRecoveryStatusColor = "#E0E0E0";

export const showCommissionType = ["terminal", "tablet"];

export const businessDevicesDetailFields = [
  ["MerchantDeviceId", "AppVersion", "OSVersion"],
  ["PingDate", "SSID", "DeviceId"],
  ["MACAddress", "SerialNumber", "DeviceType"],
  ["Model", "IMEI", "IsCommissioned"],
  ["RegistrationId"]
];

export const businessDevicesDetailDateFields = ["PingDate"];
